import React, { Fragment, useState, useEffect } from "react";
import FsLightbox from "fslightbox-react";
import Chart from "react-apexcharts";
import { useParams } from "react-router-dom";
import { Row, Col, Nav, Tab, Modal } from "react-bootstrap";
import Card from "../../Card";
import { FiUser, FiCalendar } from "react-icons/fi";

import { getHostelDetails } from "../../../services/OrganisationServices/hostelManagmentService";
import {
  useSharedState,
  useGlobalState,
} from "../../../services/hostelConst.js";
import OpenHostelApplicationTable from "./open-hostel-applitcation-table";
import RejectedHostelApplicationTable from "./rejected-hostel-application-table";

const HostelApplicationDetailsPage = () => {
  const [sharedState, setSharedState] = useSharedState();
  var { id } = useParams();

  const { hostelMenuState, toggleHostelMenu, openModal, modalState } =
    useGlobalState();

  const [hostelDetails, setHostelDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [createdBy, setCreatedBy] = useState("loading...");
  const [createdOn, setCreatedOn] = useState("loading...");
  const [modifiedBy, setModifiedBy] = useState("loading...");

  useEffect(() => {
    openModal({ ...modalState, id: id });
    setSharedState(true);
    toggleHostelMenu(true);
    const fetchHostelDetails = async () => {
      try {
        const response = await getHostelDetails(id);
        if (response.status === "success") {
          console.log("Hostel details:", response.data);
          setCreatedBy(response.data["CREATED BY"]);
          setCreatedOn(response.data["CREATED ON"]);
          setModifiedBy(response.data["MODIFIED BY"]);

          setHostelDetails(response.data);
        }
      } catch (error) {
        console.error("Error fetching hostel details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchHostelDetails();
    }
  }, []);

  return (
    <Fragment>
      <Tab.Container defaultActiveKey="first">
        <Row>
          <Col lg="12">
            <Card>
              <Card.Body>
                <div className="row g-3">
                  <div className="col-9">
                    <div className="mb-4">
                      <h4 className="me-2 h4 mb-0">Application</h4>
                    </div>
                    <div style={{ marginBottom: "4rem" }}></div>
                    <div className="mt-4">
                      <Nav
                        as="ul"
                        className="nav-tabs mb-0 text-center profile-tab"
                        data-toggle="slider-tab"
                        id="profile-pills-tab"
                        role="tablist"
                      >
                        <Nav.Item as="li" className="me-3">
                          <Nav.Link eventKey="first">Open</Nav.Link>
                        </Nav.Item>
                        <Nav.Item as="li" className="me-3">
                          <Nav.Link eventKey="third">Rejected</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="d-flex flex-column  ">
                      <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiUser className="text-primary fs-6" />
                        </div>
                        <div>
                          <small className="text-muted d-block">
                            Created By
                          </small>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {createdBy}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiCalendar className="text-success fs-6" />
                        </div>
                        <div>
                          <small className="text-muted d-block">
                            Created On
                          </small>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {createdOn}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiCalendar className="text-success fs-6" />
                        </div>
                        <div>
                          <small className="text-muted d-block">
                            Modified By
                          </small>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {modifiedBy}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg="12">
            <Tab.Content className="profile-content">
              <Tab.Pane eventKey="first" id="profile-feed">
                <OpenHostelApplicationTable />
              </Tab.Pane>

              <Tab.Pane eventKey="third" id="profile-friends">
                <RejectedHostelApplicationTable />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Fragment>
  );
};

export default HostelApplicationDetailsPage;
